import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import './FilterModal.scss'

const FilterModal = props => {
  let menus = []
  let dropdownIdx = 0
  for (let label in props.filterOptions) {
    const optionInfo = props.filterOptions[label]
    const filteredAttributes = props.filtered[label]
    let clearLabel
    if (filteredAttributes && filteredAttributes.length > 0) {
      clearLabel = (
        <div
          className='clear-selection'
          onClick={() => {
            props.onClear(label)
          }}
        >
          Clear{' '}
          {Array.isArray(filteredAttributes)
            ? `(${filteredAttributes.length})`
            : ''}
        </div>
      )
    }

    const shownLabel = optionInfo.displayedLabel
      ? optionInfo.displayedLabel
      : label

    menus.push(
      <div className='FilterModal__option filter-section' key={dropdownIdx}>
        <div className='FilterModal__optionHeader'>
          {shownLabel}
          {clearLabel}
        </div>
        {optionInfo.renderDropdownContent(true, true)}
      </div>
    )
    dropdownIdx++
  }

  return (
    <Modal show={props.active}>
      <div className='FilterModal'>
        <div className='FilterModal__top'>
          <h1>Filter Results</h1>
          <div className='FilterModal__close' onClick={props.onHide}>
            &times;
          </div>
        </div>
        <div className='FilterModal__menus'>{menus}</div>
      </div>
    </Modal>
  )
}

FilterModal.propTypes = {
  active: PropTypes.bool,
  filtered: PropTypes.object,
  filterOptions: PropTypes.object,
  onClear: PropTypes.func,
  onHide: PropTypes.func
}

export default FilterModal
